import { useCallback, useEffect, useState } from 'react'
import { isAfter } from 'date-fns'
import { ShowtimeReleaseType } from '@/types/codegen-federation'
import { getObjectFromLocalStorage, writeToLocalStorage } from '@/utils/local-storage/local-storage'

const RELEASE_TYPE_FILTER_STORAGE_KEY = 'releaseTypeFilter'
interface ReleaseTypeFilterStorage {
  value: ShowtimeReleaseType[]
  expires: Date
}

export const useReleaseTypeFilter = (key: string, initialState: ShowtimeReleaseType[] = []) => {
  const [releaseTypeFilter, setReleaseTypeFilter] = useState<ShowtimeReleaseType[]>(initialState)
  const storageKey = `${RELEASE_TYPE_FILTER_STORAGE_KEY}-${key}`

  const wrappedSetReleaseTypeFilter = useCallback(
    (value: ShowtimeReleaseType[]) => {
      setReleaseTypeFilter(value)
      writeToLocalStorage(storageKey, {
        value,
        expires: new Date(Date.now() + 1000 * 60 * 60 * 24),
      })
    },
    [storageKey],
  )

  useEffect(() => {
    const savedReleaseTypeFilter = getObjectFromLocalStorage<ReleaseTypeFilterStorage>(storageKey)
    if (savedReleaseTypeFilter && isAfter(savedReleaseTypeFilter.expires, new Date())) {
      setReleaseTypeFilter(savedReleaseTypeFilter.value)
    }
  }, [storageKey])

  return [releaseTypeFilter, wrappedSetReleaseTypeFilter] as const
}
